import React, { useState, useEffect } from "react";
import "../styles/components/slider.css";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../utils/dateUtil";
import ArrowIcon from "../assets/icons/slider-arrow.svg";
import InfoIcon from "../assets/icons/info-icon-white.svg";

export default function Slider({ imagesData, styleType, contentType }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const imagesLength = imagesData?.length || 0;

  useEffect(() => {
    if (imagesLength <= 1) return;
    const timer = setTimeout(() => {
      setCurrentIndex((i) => (i === imagesLength - 1 ? 0 : i + 1));
    }, 5000);
    return () => clearTimeout(timer);
  }, [currentIndex, imagesLength]);

  const goToNext = () =>
    setCurrentIndex((i) => (i === imagesLength - 1 ? 0 : i + 1));
  const goToPrev = () =>
    setCurrentIndex((i) => (i === 0 ? imagesLength - 1 : i - 1));
  const goToSlide = (idx) => setCurrentIndex(idx);

  const showArrows = imagesLength > 1;
  const sliderClass = styleType === "small" ? "slider-small" : "slider-large";

  return (
    <div>
      <div className={`slider-container ${sliderClass}`}>
        <div
          className="slider-wrapper"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {imagesData.map((item) => (
            <div className="slide" key={item.id}>
              <img
                src={item.url}
                alt=""
                className="slide-blur-bg"
              />

              <img
                src={item.url}
                alt={`Slide ${item.id}`}
                className="slider-image"
              />

              <div className="slide-black-screen" />

              <div className="slide-content">
                <div className="slide-text">
                  <span className="slide-date">{formatDate(item.date)}</span>
                  <h2 className="slide-title">{item.title}</h2>
                  <p className="slide-description">{item.description}</p>
                  <button
                    className="slide-details-button"
                    onClick={() =>
                      navigate(`/about_company/news/details/${item.id}`, {
                        state: { type: contentType },
                      })
                    }
                  >
                    <img src={InfoIcon} alt="Подробнее" />Подробнее
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {showArrows && (
          <>
            <button className="arrow arrow-left" onClick={goToPrev}>
              <img src={ArrowIcon} alt="Prev" />
            </button>
            <button className="arrow arrow-right" onClick={goToNext}>
              <img src={ArrowIcon} alt="Next" />
            </button>
          </>
        )}
      </div>

      <div className="indicator-wrapper">
        {imagesData.map((_, idx) => (
          <div
            key={idx}
            className={`indicator ${idx === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(idx)}
          />
        ))}
      </div>
    </div>
  );
}
